const GET_EXPORT_BENEFICIARIES_STATE = 'getExportBeneficiariesState';
const EXPORT_BENEFICIARIES_STATE = 'exportBeneficiariesState';

export { GET_EXPORT_BENEFICIARIES_STATE, EXPORT_BENEFICIARIES_STATE };
